import { useTranslation } from "next-i18next";
import Text from "ab-text";
import Link from "ab-link";
import "./ab-informes.scss";

const Informes = ({ title = "Nuestros informes", text, informes, i18n }) => {
  const { t } = useTranslation("common", { i18n });
  return (
    <div className="ab-informes">
      <div className="details">
        <Text element="h2">{title}</Text>

        <Text>{text}</Text>
      </div>

      <div className="informes">
        {informes ? (
          informes.map((itm) => (
            <div className="informe-card">
              <img src={itm?.image?.mediaItemUrl} alt={itm.title} />
              <Text element="h4">{itm.title}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href={itm?.archivo?.mediaItemUrl}
                target="_blank"
              />
            </div>
          ))
        ) : (
          <>
            <div className="informe-card">
              <img
                src="/images/informe-1.png"
                alt={t("memoriaRSE") + " " + "2020"}
              />
              <Text element="h4">{t("memoriaRSE") + " " + "2020"}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href="https://www.abadia-retuerta.com/wp-content/uploads/2021/04/Memoria-Responsabilidad-social-empresarial-2020-2.pdf"
                target="_blank"
              />
            </div>

            <div className="informe-card">
              <img
                src="/images/informe-2.png"
                alt={t("memoriaRSE") + " " + "2019"}
              />
              <Text element="h4">{t("memoriaRSE") + " " + "2019"}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href="https://www.abadia-retuerta.com/wp-content/uploads/2021/04/Informe-de-Responsabilidad-Social-Empresarial-2019.pdf"
                target="_blank"
              />
            </div>

            <div className="informe-card">
              <img
                src="/images/informe-3.png"
                alt={t("memoriaRSE") + " " + "2018"}
              />
              <Text element="h4">{t("memoriaRSE") + " " + "2018"}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href="https://www.abadia-retuerta.com/wp-content/uploads/2020/11/memoria-RSE-Abadia-Retuerta-cas-2018.pdf"
                target="_blank"
              />
            </div>

            <div className="informe-card">
              <img
                src="/images/informe-4.png"
                alt={t("memoriaRSE") + " " + "2017"}
              />
              <Text element="h4">{t("memoriaRSE") + " " + "2017"}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href="https://www.abadia-retuerta.com/wp-content/uploads/2019/06/Memoria-RSE-ARLD-2017-2.pdf"
                target="_blank"
              />
            </div>

            <div className="informe-card">
              <img
                src="/images/informe-5.png"
                alt={t("memoriaRSE") + " " + "2016"}
              />
              <Text element="h4">{t("memoriaRSE") + " " + "2016"}</Text>
              <Link
                prefetch={false}
                text={t("descargar")}
                href="https://www.abadia-retuerta.com/wp-content/uploads/2019/06/Memoria-RSE-ARLD-2016-10.pdf"
                target="_blank"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Informes;
